import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import swal from "sweetalert2";
@Component({
  selector: 'app-privacy-settings',
  templateUrl: './privacy-settings.component.html',
  styleUrls: ['./privacy-settings.component.css']
})
export class PrivacySettingsComponent implements OnInit {
  privacyDetails: any = [];

  @Input()
  set privacyData(data: string) {
    this.privacyDetails = data;
  }
  
  @Output() notificationEvent = new EventEmitter<any>();

  constructor(private rolesSharedService: RolesSharedService) { }

  ngOnInit() {

  }

  updatePrivacy(data) {
    this.rolesSharedService.updatePrivacySettings(data).subscribe((rsp: any) => {
      swal("Success", "Settings updated successfully", "success");
    }, error => {
      swal("Info", error.error.error.message, "info");
    });
  }

  OnChange(event: any, id) {
    const data = {
      "userPrivacySettingId": id,
      "visibility": event.target.checked ? 'all' : 'none',
    }
    this.updatePrivacy(data);
  }
}


// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/privacy-settings/privacy-settings.component.ts